import { useState, useEffect } from 'react'
import PushNotification from 'react-web-notification'
import watcher from '../utils/capture-watcher'
import { ICapture } from '../types'

type IPushData = {
    title: string
    message: string
    clickthroughUrl?: string
}

const CapturePushNotification = () => {
    const [permissionGranted, setPermissionGranted] = useState(false)
    const [pushData, setPushData] = useState<IPushData>()

    const onCaptureComplete = (capture: ICapture) => {
        const success = capture.status.toLowerCase() === 'done'
        setPushData({
            title: 'GIPHY Supercut - ' + capture.title,
            message: success ? 'Completed successfully' : 'Failed to process',
            clickthroughUrl: success ? '/supercut/detail/' + capture.id : undefined,
        })
    }

    useEffect(() => {
        watcher.addListener(onCaptureComplete)
        return () => watcher.removeListener(onCaptureComplete)
    }, [])

    if (pushData) {
        console.log(pushData)
    }

    return (
        <PushNotification
            ignore={!permissionGranted || !pushData}
            disableActiveWindow={false}
            askAgain={true}
            onPermissionGranted={() => setPermissionGranted(true)}
            onShow={() => setPushData(undefined)}
            onError={() => setPushData(undefined)}
            title={pushData?.title || ''}
            options={{
                body: pushData?.message || '',
                requireInteraction: true,
                icon: 'https://giphy.com/static/img/supercut/push-notification-icon.png',
            }}
            onClick={() => {
                if (pushData?.clickthroughUrl) {
                    window.location.href = pushData!.clickthroughUrl!
                }
            }}
        />
    )
}

export default CapturePushNotification
